























































































import moment from "moment";
import Player from "@vimeo/player";
import { attachVimeoAnalytics } from "@/utils/vimeoAnalytics/vimeoAnalytics";
import {
  VIDEO_STARTED,
  VIDEO_PROGRESS,
  VIDEO_COMPLETED,
  VIDEO_PAUSED,
  VIDEO_SEEKED,
  VIDEO_CAPTIONS_CHANGED,
  VIDEO_FULLSCREEN_CHANGED,
  VIDEO_ENTER_PICTURE_IN_PICTURE,
  VIDEO_LEAVE_PICTURE_IN_PICTURE,
  VIDEO_QUALITY_CHANGED,
  VIDEO_PLAYBACK_RATE_CHANGED,
  VIDEO_VOLUME_CHANGED,
  VIDEO_BUFFER_START,
  VIDEO_BUFFER_END,
} from "@/utils/analyticsEvents";
import type enLang from "@/assets/lang/_en.json";

export default {
  name: "EventVideo",
  props: {
    event: { type: Object, required: true },
    test: { type: Boolean, default: false },
  },
  data() {
    return {
      disclaimerVisible: false,
      videoReload: false,
      vimeoPlayer: null as Player | null,
    };
  },
  mounted() {
    if (this.videoAvailable) this.initVimeoAnalytics();
  },
  beforeDestroy() {
    if (this.vimeoPlayer) {
      this.vimeoPlayer.destroy();
      this.vimeoPlayer = null;
    }
  },
  methods: {
    initVimeoAnalytics(): void {
      this.$nextTick(() => {
        const videoWrapElement = this.$refs.videoWrap as HTMLElement | undefined;
        if (!videoWrapElement) return;
        this.vimeoPlayer = attachVimeoAnalytics(
          videoWrapElement,
          {
            video_id: this.event.id,
            video_title: this.event.title,
            content_type: "gym_class",
            video_category: this.event.type,
          },
          {
            videoStartedEvent: VIDEO_STARTED,
            videoProgressEvent: VIDEO_PROGRESS,
            videoCompletedEvent: VIDEO_COMPLETED,
            videoPausedEvent: VIDEO_PAUSED,
            videoSeekedEvent: VIDEO_SEEKED,
            videoCaptionsChangedEvent: VIDEO_CAPTIONS_CHANGED,
            videoFullscreenChangedEvent: VIDEO_FULLSCREEN_CHANGED,
            videoEnterPictureInPictureEvent: VIDEO_ENTER_PICTURE_IN_PICTURE,
            videoLeavePictureInPictureEvent: VIDEO_LEAVE_PICTURE_IN_PICTURE,
            videoQualityChangedEvent: VIDEO_QUALITY_CHANGED,
            videoPlaybackRateChangedEvent: VIDEO_PLAYBACK_RATE_CHANGED,
            videoVolumeChangedEvent: VIDEO_VOLUME_CHANGED,
            videoBufferStartEvent: VIDEO_BUFFER_START,
            videoBufferEndEvent: VIDEO_BUFFER_END,
          },
        );
      });
    },
  },
  computed: {
    videoAvailable(): boolean {
      if (this.test) return true;
      if (this.videoReload) return false;
      const now = moment();
      const vidAvailable = moment(this.event.start_date_time);
      return now > vidAvailable || now.isSame(vidAvailable, "day");
    },
    showReminder(): boolean {
      const now = moment();
      const vidAvailable = moment(this.event.start_date_time);
      return now < vidAvailable;
    },
    decodedEmbed(): string {
      return this.event.embed_code ? atob(this.event.embed_code) : "";
    },
    componentText(): typeof enLang["liveEvent"] {
      return this.getText.liveEvent;
    },
  },
};
